<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}

.interact_right{width:64vw;height: 45vw;background-color: #fffff9;margin: 0;padding: 0;overflow: hidden;margin-top:6vw;float: left;
border: #e3e3e3 solid 1px;box-sizing: border-box; border-left: 0;} 
.interact_right input.h_title{width: 60vw;margin: 0 auto;height: 5vw;display: block;border: 0;border-bottom: #ddd solid 1px;border-radius: 0;
font-size: 1.6vw;color: #3465ff;}
.interact_right input.h_title::placeholder{color: #3465ff;}
.qd_qu{width: 60vw;height:  8vw;margin: 0 auto;border-bottom:#ddd solid 1px;overflow: hidden;border-bottom: #ddd solid 1px;}
.qd_qu img{width: 4vw;margin-top: 2vw;display: block;float: left;}
.qd_qu span{display: block;float: left;line-height: 8vw;font-size: 1.4vw;color: #000;width: 50vw;margin-left: 1vw;text-overflow: ellipsis;
white-space: nowrap;overflow: hidden;}
.qd_an{width: 60vw;height:  30vw;margin: 0 auto;border-bottom:#ddd solid 1px;overflow: hidden;border-bottom: #ddd solid 1px;}
.qd_an img{width: 4vw;margin-top: 2vw;display: block;float: left;}
.qd_an p{display: block;float: left;line-height: 3vw;font-size: 1.4vw;color: #000;width: 50vw;margin-left: 1vw;margin-top: 2vw;}
.qd_foot{width: 60w;height: 6vw;margin: 0 auto;}
.qd_foot button{display: block;float: left;width: 12vw;height: 4vw;outline: none;border: 0;margin-top: 1vw;color: #fff;font-size: 1.6vw;}
.qd_foot button.qd1{margin-left: 2vw;background-color: #8cb4ec;}
.qd_foot button.qd2{margin-left: 1vw;background-color: #bcbcbc;}
</style>
<template>
	<div class="bg343">

         
	     <u_center></u_center>
	     <interact :main="main" :sub="sub" :title="title"></interact>
	     <div class="interact_right">
	     	  <div class="qd_qu">
	     	  	<img src="../../../static/images/qu.png">
	     	  	<span>请问俄罗斯和乌克兰为什么要干仗？</span>
	     	  </div>
	     	  <div class="qd_an">
                    <img src="../../../static/images/an.png">
	     	  	<p>因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴
	     	  	因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴因为红鲤鱼绿鲤鱼与驴</p>
	     	  </div>
	     	  <div class="qd_foot">
	     	  	<button class="qd1">提交</button>
	     	  	<button class="qd2">新增下一个</button>
	     	  </div>
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import interact from '@/components/interact.vue'; 
	export default {
	    components: {
		  u_center,
		  interact
	    },
		data() {
			return {
				token:"",
				main:3,
				sub:"",
				title:"新增Q&A",
				uploaded:false
			}
		},
		mounted() {
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  
			  } 

		},
		methods: {
			vote_add(){
                   this.$router.push("/vote_add");  
			},
			 add_template(){	 
              if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
              }
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/add_template', {
					   token:self.token,
					   type:self.type,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){
				             self.$toast.center('添加成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		},watch:{
			   content(){
			     this.current_length=  this.$refs.count.value.length; 		      
			     this.count=Math.ceil(this.current_length/70);
			   }
              
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/interact/qa_add.vue